import { ActionMapInterface } from 'components/pages/base/topControlBlock/TopControlBlock';
import { PersonPageTopActionsEnum } from 'components/interfaces/PersonInterface';
import { ResponseWithIdSimpleApi } from 'submodules/api_middleware';
import { createApplication } from 'services/application.service';
import { getRoute } from 'constants/routes';
import { playerRegistrationTerminate } from 'services/player.service';
import { getDiscipline } from 'utils/helpers/browser/discipline';

function getCreateApplicationsCb(personId: number, type: string) {
    return async () => {
        const data: ResponseWithIdSimpleApi = await createApplication(type, {
            person_id: personId,
        });
        if (data.id) {
            window.pageRedirect(getRoute('/applications/{0}', [data.id]));
            return;
        }
    };
}

export const getActionsMapPersonProfilePage = (
    personId: number,
    openPrintEnvelopeModal: () => void
): ActionMapInterface => ({
    [PersonPageTopActionsEnum.terminate_player_owner_club]: {
        localization: 'MemberDetails.actions.terminate_player_owner_club',
        confirmModal: {
            cb: () =>
                playerRegistrationTerminate(personId, {
                    discipline: getDiscipline(),
                }),
            titleKey: 'MemberDetails.actions.terminate_player_owner_club',
            textKey: 'TopControlConfirmModal.default_text',
        },
    },
    [PersonPageTopActionsEnum['register-player']]: {
        localization: 'actions.registerPlayer',
        cb: () => console.log('archive'),
    },
    [PersonPageTopActionsEnum['transfer']]: {
        localization: 'actions.transfer',
        cb: () => console.log('archive'),
    },
    [PersonPageTopActionsEnum['request-from-abroad']]: {
        localization: 'actions.requestFromAbroad',
        cb: () => console.log('archive'),
    },
    [PersonPageTopActionsEnum['player_registration']]: {
        localization: 'actions.playerRegistration',
        confirmModal: {
            ownCb: getCreateApplicationsCb(personId, 'player_registration'),
            titleKey: 'actions.playerRegistration',
            textKey: 'TopControlConfirmModal.application_confirm_text',
        },
    },
    [PersonPageTopActionsEnum['amateur_player_transfer']]: {
        localization: 'actions.amateurPlayerTransfer',
        confirmModal: {
            ownCb: getCreateApplicationsCb(personId, 'amateur_player_transfer'),
            titleKey: 'actions.amateurPlayerTransfer',
            textKey: 'TopControlConfirmModal.application_confirm_text',
        },
    },
    [PersonPageTopActionsEnum['professional_player_sub_hosting']]: {
        localization: 'actions.professional_player_sub_hosting',
        confirmModal: {
            ownCb: getCreateApplicationsCb(
                personId,
                'professional_player_sub_hosting'
            ),
            titleKey: 'actions.professional_player_sub_hosting',
            textKey: 'TopControlConfirmModal.application_confirm_text',
        },
    },
    [PersonPageTopActionsEnum['player_school_transfer_termination']]: {
        localization: 'actions.player_school_transfer_termination',
        confirmModal: {
            ownCb: getCreateApplicationsCb(
                personId,
                'player_school_transfer_termination'
            ),
            titleKey: 'actions.player_school_transfer_termination',
            textKey: 'TopControlConfirmModal.application_confirm_text',
        },
    },
    [PersonPageTopActionsEnum['professional_player_hosting']]: {
        localization: 'actions.professional_player_hosting',
        confirmModal: {
            ownCb: getCreateApplicationsCb(
                personId,
                'professional_player_hosting'
            ),
            titleKey: 'actions.professional_player_hosting',
            textKey: 'TopControlConfirmModal.application_confirm_text',
        },
    },
    [PersonPageTopActionsEnum['player_hosting_extension']]: {
        localization: 'actions.player_hosting_extension',
        confirmModal: {
            ownCb: getCreateApplicationsCb(
                personId,
                'player_hosting_extension'
            ),
            titleKey: 'actions.player_hosting_extension',
            textKey: 'TopControlConfirmModal.application_confirm_text',
        },
    },
    [PersonPageTopActionsEnum['player_sub_hosting_termination']]: {
        localization: 'actions.player_sub_hosting_termination',
        confirmModal: {
            ownCb: getCreateApplicationsCb(
                personId,
                'player_sub_hosting_termination'
            ),
            titleKey: 'actions.player_sub_hosting_termination',
            textKey: 'TopControlConfirmModal.application_confirm_text',
        },
    },
    [PersonPageTopActionsEnum['player_sub_hosting_extension']]: {
        localization: 'actions.player_sub_hosting_extension',
        confirmModal: {
            ownCb: getCreateApplicationsCb(
                personId,
                'player_sub_hosting_extension'
            ),
            titleKey: 'actions.player_sub_hosting_extension',
            textKey: 'TopControlConfirmModal.application_confirm_text',
        },
    },
    [PersonPageTopActionsEnum['professional_player_transfer']]: {
        localization: 'actions.professional_player_transfer',
        confirmModal: {
            ownCb: getCreateApplicationsCb(
                personId,
                'professional_player_transfer'
            ),
            titleKey: 'actions.professional_player_transfer',
            textKey: 'TopControlConfirmModal.application_confirm_text',
        },
    },
    [PersonPageTopActionsEnum['international_player_transfer']]: {
        localization: 'actions.internationalPlayerTransfer',
        confirmModal: {
            ownCb: getCreateApplicationsCb(
                personId,
                'international_player_transfer'
            ),
            titleKey: 'actions.internationalPlayerTransfer',
            textKey: 'TopControlConfirmModal.application_confirm_text',
        },
    },
    [PersonPageTopActionsEnum['player_hosting_termination']]: {
        localization: 'actions.playerHostingTermination',
        confirmModal: {
            ownCb: getCreateApplicationsCb(
                personId,
                'player_hosting_termination'
            ),
            titleKey: 'actions.playerHostingTermination',
            textKey: 'TopControlConfirmModal.application_confirm_text',
        },
    },
    [PersonPageTopActionsEnum['player_transfer_to_abroad']]: {
        localization: 'actions.playerTransferToAbroad',
        confirmModal: {
            ownCb: getCreateApplicationsCb(
                personId,
                'player_transfer_to_abroad'
            ),
            titleKey: 'actions.playerTransferToAbroad',
            textKey: 'TopControlConfirmModal.application_confirm_text',
        },
    },
    [PersonPageTopActionsEnum['member_termination']]: {
        localization: 'actions.memberTermination',
        confirmModal: {
            ownCb: getCreateApplicationsCb(personId, 'member_termination'),
            titleKey: 'actions.memberTermination',
            textKey: 'TopControlConfirmModal.application_confirm_text',
        },
    },
    [PersonPageTopActionsEnum['member_roles_termination']]: {
        localization: 'actions.memberRoleTermination',
        confirmModal: {
            ownCb: getCreateApplicationsCb(
                personId,
                'member_roles_termination'
            ),
            titleKey: 'actions.memberRoleTermination',
            textKey: 'TopControlConfirmModal.application_confirm_text',
        },
    },
    [PersonPageTopActionsEnum['print_cover']]: {
        localization: 'actions.printEnvelope',
        cb: openPrintEnvelopeModal,
    },
});
